import { SVGProps } from "react";

export const IconLocation: React.FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33335 13C5.96825 13.5578 5.9679 13.5576 5.9679 13.5576L5.96617 13.5564L5.96227 13.5538L5.94913 13.5451C5.93805 13.5377 5.92234 13.5272 5.90233 13.5136C5.8623 13.4864 5.805 13.4469 5.73289 13.3957C5.58874 13.2935 5.385 13.1445 5.14149 12.9542C4.65556 12.5743 4.00576 12.0251 3.35361 11.3493C2.0781 10.0274 0.666687 8.09074 0.666687 5.90907C0.666687 2.81819 3.21533 0.333313 6.33335 0.333313C9.45138 0.333313 12 2.81819 12 5.90907C12 8.09074 10.5886 10.0274 9.3131 11.3493C8.66095 12.0251 8.01115 12.5743 7.52522 12.9542C7.28171 13.1445 7.07797 13.2935 6.93382 13.3957C6.86171 13.4469 6.8044 13.4864 6.76438 13.5136C6.74436 13.5272 6.72866 13.5377 6.71757 13.5451L6.70444 13.5538L6.70054 13.5564L6.69927 13.5572C6.69927 13.5572 6.69846 13.5578 6.33335 13ZM6.33335 13L6.69927 13.5572C6.47751 13.7024 6.18966 13.7027 5.9679 13.5576L6.33335 13ZM4.00002 5.90907C4.00002 4.62566 5.05627 3.60604 6.33335 3.60604C7.61043 3.60604 8.66669 4.62566 8.66669 5.90907C8.66669 7.19248 7.61043 8.2121 6.33335 8.2121C5.05627 8.2121 4.00002 7.19248 4.00002 5.90907Z"
        fill="currentColor"
      />
    </svg>
  );
};
